import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { BinStatusFilter } from '../BinStatusFilter';
import { BinStatusContext } from '../../../../../context/BinStatusContext';

interface BinStatusFilterDropdownContentProps {
  filter: BinStatusFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function BinStatusFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: BinStatusFilterDropdownContentProps) {
  const { binStatuses } = useContext(BinStatusContext);

  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    const items = new Set<string>();
    for (const status of binStatuses.values()) {
      if (!filter.search(status, query)) continue;
      if (filterProps.company?.size && !filterProps.company.has(status.companyId)) continue;
      items.add(status.id);
    }
    return items;
  }, [query, binStatuses, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.binStatus = selected;
    if (!filterProps.binStatus?.size) filterProps.binStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.binStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.bin).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.binStatus}
          values={values}
          onChange={handleChange}
          toText={id => `${binStatuses.get(id)?.status}`}
        />
      </Grid>
    </Grid>
  );
}
